import create from '~/misc/create';
import types from './types';
import {loadsRate, fuelPrice, loadsCount, trucksCount, getRateSwitchApi} from '~/api/rate';
import {promiseAction} from '~/misc/dispatch';
import HTTPError from '~/misc/HTTPError';

// 获取loads平均利润值
export const getRateAverage = data => (dispatch, getState) => {
  const {pickup, dropOff, equipment, interval} = data;
  const obj = {
    pickup: {
      lng: pickup.lng,
      lat: pickup.lat,
      address: `${pickup.city },${ pickup.state}`,
    },
    drop_off: {
      lng: dropOff.lng,
      lat: dropOff.lat,
      address: `${dropOff.city },${ dropOff.state}`,
    },
    equipment: equipment,
    interval: interval || "THIRTY"
  };
  return loadsRate(getState, obj)
    .then(response => {
      dispatch(create(types.INIT_RATE_CHECK, {
        sdRateAverage: response.avg_rate.value,
        sdSumDistance: response.sum_distance.value,
        sdSumPrice: response.sum_price.value,
      }));
    });
};
// 获取油价
export const getFuelPrice = data => (dispatch, getState) => {
  const {pickup, dropOff} = data;
  const obj = {
    fromLng: pickup.lng,
    fromLat: pickup.lat,
    toLng: dropOff.lng,
    toLat: dropOff.lat,
  };
  fuelPrice(getState, obj)
    .then(response => {
      dispatch(create(types.INIT_RATE_CHECK, {fuelPriceAvg: response.price}));
    });
};
// 获取Loads数量
export const getLoadsCount = data => (dispatch, getState) => {
  const {pickup, dropOff, equipment, deadhead} = data;
  const obj = {
    pickup: {
      lng: pickup.lng,
      lat: pickup.lat,
      address: `${pickup.city },${ pickup.state}`,
    },
    drop_off: {
      lng: dropOff.lng,
      lat: dropOff.lat,
      address: `${dropOff.city },${ dropOff.state}`,
    },
    equipment: equipment,
    deadhead: deadhead,
  };
  loadsCount(getState, obj)
    .then(response => {
      dispatch(create(types.INIT_RATE_CHECK, {
        pickLoads: response.pickup.value,
        dropLoads: response.drop_off.value,
      }));
    });
};
// 获取trucks数量
export const getTrucksCount = data => (dispatch, getState) => {
    const {pickup, dropOff, equipment, deadhead} = data;
    const obj = {
        fromLng: pickup.lng,
        fromLat: pickup.lat,
        toLng: dropOff.lng,
        toLat: dropOff.lat,
        maxDeadhead: deadhead,
        trailerType: equipment
    }
    trucksCount(getState, obj)
        .then(response => {
            dispatch(create(types.INIT_RATE_CHECK, {
                pickTruck: response['pickCount'],
                dropTrucks: response['dropCount']
            }))
        });
}
export const setCalculate = data => (dispatch, getState) => {
  const {fuelPrice, basePrice, milesPrice} = data;
  dispatch(create(types.INIT_RATE_CHECK, {fuelPrice, basePrice, milesPrice}));
};
export const removeRateCheck = data => (dispatch, getState) => {
  dispatch(create(types.REMOVE_RATE_CHECK));
};
export const setDeadhead = data => (dispatch, getState) => {
  dispatch(create(types.INIT_RATE_CHECK, {deadhead: data}));
};

// 获取算法跟新开关
export const getRateSwitch = () => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.GET_RATE_UPDATE_SWITCH,
  getRateSwitchApi(getState).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    throw error;
  }));

// 保存rate更新用户已查看信息
export const saveRateSwitch = () => (dispatch) => dispatch(create(types.SAVE_RATE_SWITCH));




// WEBPACK FOOTER //
// ./src/modules/rate/actions.js